import { ADMIN } from 'app/common/data/roles';
import useMe from 'app/common/hooks/queries/useMeUncamel';

export const useCanSendClevertapEvents = (): boolean => {
    const { data: me } = useMe();

    return !!me && !me?.shadow_user_id && me?.role !== ADMIN;
};
